import { List } from "immutable";
import _ from "lodash";
import React from "react";
import * as BS from "react-bootstrap";
import * as Comp from "../../../../components";
import * as Forms from "../../../../forms";
import * as M from "../../../../models";
import { Api } from "../../../../services/Api";
import { Utility } from "../../../../utils";

interface OwnProps {
    api: Api;
    countries: List<M.Country.Country>;
    formComponent: Comp.Validation.IComponentWithValidatedForm;
    label?: string;
    name: string;
}

interface OwnState {
}

export class RelocationEditor extends React.Component<OwnProps, OwnState> {
    private _searchTimeout: NodeJS.Timer;

    public render() {
        const modelItems = this.props.formComponent.getFormModel<Forms.CareerCenter.PostResumeData>().data.relocationPref;

        // Build link editors
        const sortedItems = _.orderBy(modelItems, "index");
        const items = sortedItems.map((item, i) => {

            return <li key={i} className="list-builder-item" style={{ display: item.isDelete ? "none" : "block" }}>
                <div className="list-builder-fields">
                    <Comp.Editors.AddressField
                        formComponent={this.props.formComponent}
                        excludeAddressLines
                        excludeAddressType
                        excludePostalCode
                        name={this.props.name + `[${i}].location`}
                    />

                    <Comp.Editors.SelectField
                        formComponent={this.props.formComponent}
                        description={<em className="mute">&mdash; OR &mdash;</em>}
                        isAsync
                        label=""
                        name={this.props.name + `[${i}].region`}
                        select={{
                            className: "txt-med",
                            ignoreAccents: false,
                            ignoreCase: false,
                            loadOptions: (search: string) => this.searchRegions(search),
                            placeholder: "Region...",
                        }}
                    />
                </div>
                <BS.Button bsStyle="danger" className="remove-trigger" onClick={() => this.onDelete(item.index)} title="Delete location">
                    <i className="fa fa-times"></i>
                </BS.Button>
            </li>;
        });

        return <div>
            <Comp.Editors.FormField label="" name={this.props.name} noFieldWrap>
                <ul className="list-builder">
                    {items}
                </ul>
            </Comp.Editors.FormField>

            <Comp.Editors.FormField name="">
                <BS.ButtonGroup>
                    <BS.Button onClick={() => this.onAdd()}><i className="fa fa-plus"></i> Add location</BS.Button>
                </BS.ButtonGroup>
            </Comp.Editors.FormField>
        </div>;
    }

    private onAdd() {
        const formModel = this.props.formComponent.getFormModel<Forms.CareerCenter.PostResumeData>();
        formModel.data.relocationPref.push({
            ...Forms.CareerCenter.DefaultPostResumeObjects.RelocationPref(),
            index: formModel.data.relocationPref.length,
        });
        this.props.formComponent.updateFormModel(formModel);
    }

    private onDelete(slideIdx: number) {
        const formModel = this.props.formComponent.getFormModel<Forms.CareerCenter.PostResumeData>();
        const item = _.find(formModel.data.relocationPref, (s, i) => s.index === slideIdx);

        if (item)
            item.isDelete = true;

        this.props.formComponent.updateFormModel(formModel);
    }

    private searchRegions(search: string) {
        if (!search || search.length < 2)
            return Promise.resolve({ options: [] });

        return new Promise((resolve, reject) => {
            // delay the ajax call as to not make a call for each letter typed.
            if (this._searchTimeout !== undefined)
                clearTimeout(this._searchTimeout);

            this._searchTimeout = setTimeout(() => {
                const queryParams = { queryParams: { q: search } };

                // for adding new value
                const newRegion: { region: string } & M.Generic.ReactSelectOption = Utility.toReactSelectOption({ region: search }, search, search);

                this.props.api.callApi<string[]>(Api.endpoints.careerCenter.regions, queryParams)
                    .then((result) => {
                        if (result.isSuccess && result.data) {
                            let options = result.data.map((region) => {
                                return Utility.toReactSelectOption({ region }, region, region);
                            });

                            const newRegionMatch = _.find(options, (org) => {
                                return org.region.toLowerCase().trim() === newRegion.label.toLowerCase().trim();
                            });

                            if (newRegionMatch === undefined)
                                options = [newRegion, ...options];

                            options = [...options];
                            resolve({ options });
                        }
                        else
                            throw new Error(result.errors.join("; "));
                    });
            }, 375);
        }).then((data) => {
            return data;
        });
    }
}



// WEBPACK FOOTER //
// ./src/containers/careerCenter/postResume/components/RelocationEditor.tsx